import React from "react";
import {Table} from "react-bulma-components";

class PrintMultiPartList extends React.Component{

    render(){
        const jobs = this.props.jobs.results;
        let parts = [];
        if(jobs) {
            jobs.forEach(job => {
                job.work_items.forEach(work => {
                    parts.push(...work.parts);
                });
            })
            console.log(parts);
        }

        // let parts = jobs.work_items.reduce((allParts, work) => {
        //     return [...allParts, ...work.parts]
        // })

        return (
            <div>
                <Table bordered size={"fullwidth"}>
                    <thead>
                        <tr>
                            <th>Job Id</th>
                            <th>Part Description</th>
                            <th>Part Number</th>
                            <th>Supplier</th>
                            <th>Part Arrived</th>
                            <th>Part Stock</th>
                            <th>Part Used</th>
                            <th>Part Needs Replacing</th>
                        </tr>
                    </thead>
                    <tbody>
                    {parts.map((part, index) => (
                        <tr>
                            <td>{part.job}</td>
                            <td data-testid={"part-picklist-name"+index}>{part.name ?? ''}</td>
                            <td data-testid={"part-number"+index}>{part.part_number ?? ''}</td>
                            <td data-testid={"part-supplier"+index}>{part.supplier?.display_name ?? ''}</td>
                            <td>{part.arrived}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default PrintMultiPartList;